export default {"src":"/_next/static/media/remove-minus-icon.23d3add6.svg","height":24,"width":24};